import { API_BASE_URL, authFetch } from '../apiClient.ts';
import { downloadBlob } from '../utils/helperUtils.ts';

export type ContactFilter = Record<string, unknown>;

export const downloadContactsCsv = async (
  filter: ContactFilter,
  filename: string
) => {
  const url = `${API_BASE_URL}/contacts/export-csv?filter=${encodeURIComponent(
    JSON.stringify(filter)
  )}`;
  const response = await authFetch(url, { method: 'GET' });
  if (!response.ok) {
    throw new Error(`Download failed with status ${response.status}`);
  }

  downloadBlob(await response.blob(), filename);
};
